import React, { useState, useEffect } from 'react';
import { useUser } from '../context/UserContext';
import MenuLogo from '../components/MenuLogo';
import NavItem from './NavItem';

const Navigation = ({ setCurrentPage }) => {
    const { user, logoutUser } = useUser();

    let userWelcome = user.name.split(" ")[0];
    userWelcome = "Welcome " + userWelcome;
    // userWelcome = "Welcome " + userWelcome.charAt(0).toUpperCase() + userWelcome.slice(1).toLowerCase();
    // console.log(user);

    const [isOpen, setIsOpen] = useState(false);
    const [openMenu, setOpenMenu] = useState('');

    const toggleMenu = () => {
        setIsOpen(!isOpen); // Toggle the menu state
        setOpenMenu('');
    };

    // useEffect(() => {
    //     console.log('Menu', user);
    // }, []);
  
    return (
        <nav className="bg-gray-800 p-2 sticky top-0 z-50">
            <div className="container mx-auto flex justify-between items-center">
                <MenuLogo
                    setIsOpen={setIsOpen} setCurrentPage={setCurrentPage} />

                {/* Menu Links */}
                <div className="hidden custom-flex">
                    <div className="flex items-center space-x-1 px-4">
                        <NavItem
                            page={'facebook'} label={'JS Home'}
                            textConfig={'italic font-serif'}
                            setIsOpen={setIsOpen} setCurrentPage={setCurrentPage} />
                    </div>

                    {/* Spaced-out pages (only shown when user is logged in) */}
                    {user.authenticated && (
                        <div className="flex items-center space-x-8 px-8">
                            <NavItem
                                page={'chat'} label={'Chat'}
                                setIsOpen={setIsOpen} setCurrentPage={setCurrentPage} />

                            <div className="flex space-x-1">
                                <div className='relative'
                                    onMouseEnter={() => setOpenMenu('youtube')}
                                >
                                    <NavItem
                                        page={'youtube'} label={'YouTube'}
                                        setIsOpen={setIsOpen} setCurrentPage={setCurrentPage} />
                                    {/* {openMenu == 'youtube' && (
                                        <div className='absolute top-full left-0 mt-1 w-100 bg-gray-800 border border-gray-200 rounded-lg shadow-lg
                                            transition-all duration-300 ease-in-out transform opacity-100 translate-y-0 scale-100 py-2'
                                            onMouseLeave={() => setOpenMenu('')}
                                        >
                                            <div className="block px-4 py-2">
                                                <NavItem
                                                    page={'youtube'} label={'New Release'}
                                                    setIsOpen={setIsOpen} setCurrentPage={setCurrentPage} />
                                            </div>
                                            <div className="block px-4 py-2">
                                                <NavItem
                                                    page={'youtube'} label={'My Favourites'}
                                                    setIsOpen={setIsOpen} setCurrentPage={setCurrentPage} />
                                            </div>
                                        </div>
                                    )} */}
                                </div>
                            </div>

                            <NavItem
                                page={'profile'} label={'Profile'}
                                setIsOpen={setIsOpen} setCurrentPage={setCurrentPage} />
                        </div>
                    )}

                    {/* Login / Sign Up (only shown when user is not logged in) */}
                    {!user.authenticated && (
                        <div className="flex items-center space-x-1">
                            <NavItem
                                page={'login'} label={'Login'}
                                setIsOpen={setIsOpen} setCurrentPage={setCurrentPage} />
                            <div className="text-orange-300">/</div>
                            <NavItem
                                page={'signup'} label={'Sign Up'}
                                setIsOpen={setIsOpen} setCurrentPage={setCurrentPage} />
                        </div>
                    )}

                    {/* User Info and Logout (only shown when user is logged in) */}
                    {user.authenticated && (
                        <div className="flex items-center space-x-2">
                            <span className="text-orange-300 text-nowrap">{userWelcome}!</span>
                            <button
                                onClick={() => {
                                    setIsOpen(false);
                                    logoutUser();
                                    setCurrentPage('home');
                                }}
                                className="w-full bg-orange-400 text-white py-2 px-4 rounded-lg duration-300 hover:scale-105"
                            >
                                Logout
                            </button>
                        </div>
                    )}
                </div>


                <div className='flex custom-hidden justify-center items-center'>
                    {user.authenticated && (
                        <span className="text-orange-300 text-nowrap">{userWelcome}!</span>
                    )}

                    {/* Hamburger Icon (flex on Small Screens) */}
                    <div
                        className="flex flex-col space-y-1 cursor-pointer p-2"
                        onClick={toggleMenu}
                    >
                        <div
                            className={`w-6 h-0.5 bg-orange-400 transition-transform ${
                                isOpen ? 'rotate-45 translate-y-1.5' : ''
                            }`}
                        ></div>
                        <div
                            className={`w-6 h-0.5 bg-orange-400 transition-opacity ${
                                isOpen ? 'opacity-0' : ''
                            }`}
                        ></div>
                        <div
                            className={`w-6 h-0.5 bg-orange-400 transition-transform ${
                                isOpen ? '-rotate-45 -translate-y-1.5' : ''
                            }`}
                        ></div>
                    </div>                
                </div>                

                {/* Dropdown Menu Items (flex on Small Screens) */}
                <div
                    className={`absolute top-full right-0 bg-gray-800 border border-gray-200 rounded-lg shadow-lg
                        transition-all duration-300 ease-in-out transform ${
                        isOpen ? 'opacity-100 translate-y-0 scale-100' : 'hidden'
                    }`}
                >
                    <div className='block px-4 pt-2'>
                        <div className="block px-4 py-2">
                            <NavItem
                                page={'facebook'} label={'JS Home'}
                                textConfig={'italic font-serif'}
                                setIsOpen={setIsOpen} setCurrentPage={setCurrentPage} />
                        </div>
                    </div>

                    {/* Spaced-out pages (only shown when user is logged in) */}
                    {user.authenticated && (
                        <div className='block px-4 pt-2'>
                            <hr className="w-full px-4 my-2 border-t border-gray-400" />

                            <div className="block px-4 py-2">
                                <NavItem
                                    page={'chat'} label={'Chat'}
                                    setIsOpen={setIsOpen} setCurrentPage={setCurrentPage} />
                            </div>
                            <div className="block px-4 py-2">
                                <NavItem
                                    page={'youtube'} label={'YouTube'}
                                    setIsOpen={setIsOpen} setCurrentPage={setCurrentPage} />
                            </div>
                            <div className="block px-4 py-2">
                                <NavItem
                                    page={'profile'} label={'Profile'}
                                    setIsOpen={setIsOpen} setCurrentPage={setCurrentPage} />
                            </div>
                        </div>
                    )}

                    {/* Login / Sign Up (only shown when user is not logged in) */}
                    {!user.authenticated && (
                        <div className='block px-4 pb-2'>
                            <hr className="w-full px-4 my-2 border-t border-gray-400" />

                            <div className="block px-4 py-2">
                                <NavItem
                                    page={'login'} label={'Login'}
                                    setIsOpen={setIsOpen} setCurrentPage={setCurrentPage} />
                            </div>

                                <hr className="w-full px-4 my-2 border-t border-gray-400" />
                            
                            <div className="block px-4 py-2">
                                <NavItem
                                    page={'signup'} label={'Sign Up'}
                                    setIsOpen={setIsOpen} setCurrentPage={setCurrentPage} />
                            </div>
                        </div>
                    )}

                    {/* User Info and Logout (only shown when user is logged in) */}
                    {user.authenticated && (
                        <div className='block px-4 pb-2'>
                            <hr className="w-full px-4 my-2 border-t border-gray-400" />

                            <div className="block py-2">
                                <button
                                    onClick={() => {
                                        setIsOpen(false);
                                        logoutUser();
                                        setCurrentPage('home');
                                    }}
                                    className="bg-orange-400 text-white px-4 py-2 rounded-lg duration-300 hover:scale-105"
                                >
                                    Logout
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </nav>
    );
};

export default Navigation;

